/* Floating discount tab: collapsed by default on every page load. */
(function () {
  'use strict';

  const component = document.querySelector('fp-welcome-modal');
  if (!component) return;

  const toggle = component.querySelector('[data-toggle]');
  const panel = component.querySelector('[data-panel]');
  if (!toggle || !panel) return;

  const codeBox = component.querySelector('[data-discount-code]');
  const copyButton = component.querySelector('[data-copy-code]');
  const copyLabel = component.querySelector('[data-copy-label]');

  const copyDiscountCode = async () => {
    const code = codeBox?.getAttribute('data-discount-code');
    if (!code || !copyButton) return;

    try {
      await navigator.clipboard.writeText(code);
    } catch (_) {
      const fallback = document.createElement('textarea');
      fallback.value = code;
      fallback.setAttribute('readonly', '');
      fallback.style.position = 'fixed';
      fallback.style.opacity = '0';
      document.body.appendChild(fallback);
      fallback.select();
      document.execCommand('copy');
      fallback.remove();
    }

    if (copyLabel) copyLabel.textContent = 'Copied';
    copyButton.setAttribute('aria-label', 'Discount code copied');
    window.setTimeout(() => {
      if (copyLabel) copyLabel.textContent = 'Copy';
      copyButton.setAttribute('aria-label', 'Copy discount code');
    }, 1800);
  };

  copyButton?.addEventListener('click', copyDiscountCode);

  try {
    if (sessionStorage.getItem('fp-discount-dismissed') === '1') {
      component.setAttribute('hidden', '');
      return;
    }
  } catch (_) {}

  const open = () => {
    panel.removeAttribute('hidden');
    toggle.setAttribute('aria-expanded', 'true');
    component.classList.add('is-open');
    requestAnimationFrame(() => panel.querySelector('[data-dismiss], [data-close]')?.focus({ preventScroll: true }));
  };

  const close = (returnFocus = true) => {
    panel.setAttribute('hidden', '');
    toggle.setAttribute('aria-expanded', 'false');
    component.classList.remove('is-open');
    if (returnFocus) toggle.focus({ preventScroll: true });
  };

  toggle.addEventListener('click', () => {
    if (panel.hasAttribute('hidden')) open();
    else close();
  });

  component.querySelectorAll('[data-close]').forEach((element) => {
    element.addEventListener('click', () => close());
  });

  component.querySelectorAll('[data-dismiss]').forEach((element) => {
    element.addEventListener('click', () => {
      close(false);
      component.setAttribute('hidden', '');
      try { sessionStorage.setItem('fp-discount-dismissed', '1'); } catch (_) {}
    });
  });

  document.addEventListener('click', (event) => {
    if (!panel.hasAttribute('hidden') && !component.contains(event.target)) close(false);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !panel.hasAttribute('hidden')) close();
  });
})();
